







































import { defineComponent, computed } from '@vue/composition-api';
import ALink from '@/components/common/a-link/a-link.vue';
import { useAllowlist } from '@tt4b/ttam-hooks';

const name = 'ttam-placement-block-list-block-app-info';

export default defineComponent({
  name,
  components: {
    ALink,
  },
  props: {
    loading: {
      type: Boolean,
      defalut: false,
    },
    tanBlockCount: {
      type: Number,
      default: 0,
    },
    aadvid: {
      type: String,
      default: '',
    },
  },
  setup(_props, { emit }) {
    const onRefresh = () => {
      emit('refresh');
    };

    const { isBrandBlockList } = useAllowlist();

    const blockListUrl = computed(() =>
      isBrandBlockList.value
        ? `/i18n/ttam_tools/pangle_brandsafety/block_list?aadvid=${_props.aadvid}`
        : `/i18n/account/block?aadvid=${_props.aadvid}`,
    );

    return {
      name,
      blockListUrl,
      onRefresh,
    };
  },
});
